export default {
	themes: {
		light: 'Claro',
		dark: 'Escuro'
	}
};
